import { Dialog, IconButton, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { InviteToSpaceForm } from './InviteToSpaceForm'

import { SpaceType } from 'app/types'

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
        padding: theme.spacing(0.5),
        margin: theme.spacing(0.5)
    }
}))

export type CustomerType = {
    id: string
    name: string
    domains: Array<string>
    logo: string
}

type Props = {
    space: SpaceType
    isOpen: boolean
    onClose: () => void
}

export const InviteToSpaceDialog = ({ space, isOpen, onClose }: Props) => {
    const classes = useStyles()

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth={true}
            maxWidth="sm"
            PaperProps={{
                style: {
                    backgroundColor: 'transparent',
                    boxShadow:
                        '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%), 0px 11px 15px -7px rgb(0 0 0 / 20%) inset, 0px 24px 38px 3px rgb(0 0 0 / 14%) inset, 0px 9px 46px 8px rgb(0 0 0 / 12%) inset'
                }
            }}
        >
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
            </IconButton>

            <InviteToSpaceForm space={space} onClose={onClose} />
        </Dialog>
    )
}
